export default __webpack_public_path__ + "static/media/website.42851645.png";